import styled from 'styled-components';
import { typography, TypographyProps } from 'styled-system';

export const LinkTitle = styled.a`
  text-decoration: underline;
  color: #0039BB;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  margin-bottom: 13px;
`

export const JiraIssueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #4F4F4F;
  font-size: 14px;
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  & .font-600{
    font-weight: 600;
  }
  &.date{
    font-size: 12px;
    color: #4f4f4f;
  }
`

export const SimpleLink = styled.a<TypographyProps>`
  color: #0039BB;
  &:hover{
    color: #0039BB;
    text-decoration: none;
  }
  ${typography};
`